// TODO (Noah, 2024-10-09): Re-enable this rule
import type { WorkspaceDefaultProjectType } from "schemas/generated/workspaceDefaultProjectType";

import * as React from "react";

import { getPendingWorkflowHash } from "@replohq/lattice/blocks/workflow-checklist/pendingWorkflow";
import { cn } from "@replohq/lattice/utils/cn";
import { useSearchParams } from "react-router-dom";
import { isOsmanthusEnabled } from "replo-utils/lib/osmanthus";

export type AuthFormOutletContext = {
  defaultProjectType: WorkspaceDefaultProjectType;
  setDefaultProjectType: (
    defaultProjectType: WorkspaceDefaultProjectType,
  ) => void;
};

export const Screen = {
  LOGIN: "/auth/login",
  SIGNUP: "/auth/signup",
  INIT_RESET_PASSWORD: "/auth/password/reset/init",
  RESET_PASSWORD: "/auth/password/reset",
};

export const ScreenData = {
  [Screen.LOGIN]: {
    header: "Sign In",
    footerText: "Don't have a Replo account?",
    footerCtaText: "Sign up for free now",
    footerCtaRedirectTo: Screen.SIGNUP,
  },
  [Screen.SIGNUP]: {
    header: "Create your free account",
    footerText: "Already have a Replo account?",
    footerCtaText: "Sign in",
    footerCtaRedirectTo: Screen.LOGIN,
  },
  [Screen.INIT_RESET_PASSWORD]: {
    header: "Reset Password",
    footerText: "Already have a Replo account?",
    footerCtaText: "Sign in",
    footerCtaRedirectTo: Screen.LOGIN,
  },
  [Screen.RESET_PASSWORD]: {
    header: "Enter New Password",
    footerText: "Already have a Replo account?",
    footerCtaText: "Sign in",
    footerCtaRedirectTo: Screen.LOGIN,
  },
};

export const ErrorMessage = ({
  errorMessage,
  className,
}: {
  errorMessage: string | null;
  className?: string;
}) => {
  if (!errorMessage) {
    return null;
  }

  return (
    <div
      className={cn(
        "semibold h6 bg-rose-soft text-rose mb-2 rounded-sm p-2 text-sm",
        className,
      )}
    >
      {errorMessage}
    </div>
  );
};

function useNextUrl() {
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next");
  const [nextUrl = "/", nextSearchParamsAsString] = next?.split("?") ?? [
    "/",
    "",
  ];
  const nextSearchParams = new URLSearchParams(nextSearchParamsAsString);
  const nextHash = isOsmanthusEnabled() ? getPendingWorkflowHash(nextUrl) : "";

  return { nextHash, nextUrl, nextSearchParams };
}

export function useNextUrlWithPendingAppInstallationId() {
  const { nextHash, nextUrl, nextSearchParams } = useNextUrl();
  const [searchParams] = useSearchParams();

  const shopifyIntegrationId = searchParams.get("shopifyIntegrationId");
  const pendingAppInstallationId = searchParams.get("pendingAppInstallationId");
  if (shopifyIntegrationId) {
    nextSearchParams.set("shopifyIntegrationId", shopifyIntegrationId);
  } else if (pendingAppInstallationId) {
    nextSearchParams.set("pendingAppInstallationId", pendingAppInstallationId);
  }

  return { nextHash, nextUrl, nextSearchParams };
}
